import { hasItems } from "common/arrays";

export const EMPTY_FORM = {
  applicant: null,
  address: null,
  state: null,
  revenue: null,
  service: null,
  summary: null,
  experience: null,
  claims: null,
  limit: null,
  aggregate: null,
  deductible: null,
  inception: null,
  inceptionTbd: null,
  retro: null,
  renewalStep: null,
  layers: null,
  producer: null,
  subjectivities: null,
};

export const applyFormDefaults = (formData, endorsementsConfig = null) => {
  const updated = { ...formData };

  if (updated.subjectivities == null) {
    if (
      endorsementsConfig?.subjectivities &&
      endorsementsConfig?.defaultSelectedSubjectivities
    ) {
      updated.subjectivities = endorsementsConfig.defaultSelectedSubjectivities
        .map((key) => {
          const subjectivity = endorsementsConfig.subjectivities[key];
          return subjectivity
            ? {
                key: subjectivity.key,
                text: subjectivity.text,
                fulfilled: false,
              }
            : null;
        })
        .filter((x) => x != null);
    }
  }

  return updated;
};

const optionalFields = [
  "summary",
  "renewalStep",
  "inception",
  "inceptionTbd",
  "bodilyAndProperty",
  "outsideLimit",
  "limit",
  "aggregate",
  "deductible",
  "layers",
  "producer",
  "subjectivities",
];

const missingRequired = (formData) =>
  Object.entries(formData).some(
    ([k, v]) => !optionalFields.includes(k) && v == null
  );

const incompleteLayers = (formData) => {
  if (hasItems(formData.layers)) {
    return formData.layers.some(
      (layer) =>
        layer.limit == null ||
        layer.aggregate == null ||
        layer.deductible == null
    );
  } else {
    return (
      formData.limit == null ||
      formData.aggregate == null ||
      formData.deductible == null
    );
  }
};

export const VALID_FORM = { isValid: true };

export const validateForm = (formData) => {
  if (missingRequired(formData)) {
    return {
      isValid: false,
      message: "One or more required fields have not been filled in",
    };
  } else if (incompleteLayers(formData)) {
    return {
      isValid: false,
      message:
        "Please ensure there is at least one proposed cover and each option has a limit, aggregate, and deductible specified",
    };
  } else {
    return VALID_FORM;
  }
};
